module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter dedication"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page-v"
    }
  }), _vm._v("To my mother, Natella Carper, 1904–2000, an inspiring spirit who lived ninety-five years without dementia and a final year with probable vascular dementia")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("And to my sisters, Joan Hickson and Judy Stevens, with whom I share a single copy of the ApoE4 Alzheimer’s susceptibility gene")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5acbfb0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 72
// module chunks = 0